import React, { useEffect, useState } from "react";
import { DonutChart } from "@carbon/charts-react";
import { AgCharts } from "ag-charts-react";
import FilterSelector from "../Components/FilterSelector";
import { baseColors } from "../../../../utils/handlers";

function TransactionType({ data }) {
  // const [filter, setFilter] = useState("last_3_month_summary");
  const [graphData, setGraphData] = useState([]);
  const [graphData2, setGraphData2] = useState([]);
  const [activeDuration, setActiveDuration] = useState("overall_summary");
  const [barGraph, setBarGraph] = useState([]);
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({
    data: barGraph,
    series: series,
    legend: {
      item: {
        label: {
          fontSize: 11, // Change the legend font size

          fontWeight: "normal",
          color: "#637381", // Change the legend font color
        },
        marker: {
          size: 11, // Change the size of the color boxes
        },
      },
    },

    axes: [
      {
        type: "category",
        position: "bottom",
        gridLine: false,
        label: {
          fontSize: 9,
          fontWeight: "light",
          formatter: (params) => {
            // Convert 'Oct-23' to 'Oct,23'
            return params.value.replace("-", ",");
          },
        },
      },
      {
        type: "number",
        position: "left",
        label: {
          fontWeight: "normal",
          fontSize: 10,
          formatter: (params) => {
            // Format with thousand separators and add a currency symbol
            return `${formatToIndianRupees(params.value)}`;
          },
        },
        gridLine: false,
      },
    ],
    barPadding: 0.1, // Default is 0.1, lower this value to reduce bar width
    groupPadding: 0.1,
    height: 340,
  });
  const mapSeries = (data) => {
    const array = data.map((item, index) => {
      return {
        type: "bar",
        xKey: "quarter",
        yKey: item,
        yName: item,
        cornerRadius: 10,
        fill: baseColors[index % baseColors.length],
        stacked: true,
      };
    });

    return array;
  };

  const [activeLegend, setActiveLegend] = useState(graphData?.map(() => true));
  const handleLegendClick = (index) => {
    const newActiveLegend = [...activeLegend];
    newActiveLegend[index] = !newActiveLegend[index];
    setActiveLegend(newActiveLegend);
  };

  const [colorMap, setColorMap] = useState({});
  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(3)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toFixed(2).toString();
    // return num.toString();
  }

  const legendItems = graphData?.map((item, index) => (
    <div
      key={index}
      onClick={() => handleLegendClick(index)}
      className={` flex items-center cursor-pointer w-[32%] h-[30px]  ${
        activeLegend[index] ? "opacity-100" : "opacity-50"
      }`}
    >
      <span
        className={` inline-block w-[10px] h-[10px] rounded-[2px]  `}
        style={{
          backgroundColor:
            colorMap[item.group] || baseColors[index % baseColors.length],
        }}
      />
      <p className=" text-[#637381] text-xs ml-[10px]">{item.group}</p>
    </div>
  ));
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });
  }
  const formatCenterValue = (value) => {
    return `₹${indianNumberFormat(value)}`;
  };
  const options1 = {
    title: null,
    toolbar: false,
    tooltip: {
      valueFormatter: (tooltipValue, label) =>
        `${formatToIndianRupees(tooltipValue)}`,
    },
    legend: {
      enabled: false,
      alignment: "center",
    },

    color: {
      scale: colorMap,
      getFillColor: (dataPoint) => colorMap[dataPoint.group],
    },

    resizable: true,
    donut: {
      center: {
        label: "Total Value",
      },
      alignment: "center",
    },
    pie: {
      labels: {
        formatter: (value) => void 0,
      },
    },
    height: "200px",
  };
  const options2 = {
    title: null,
    toolbar: false,

    legend: {
      enabled: false,
      alignment: "center",
    },

    color: {
      scale: colorMap,
      getFillColor: (dataPoint) => colorMap[dataPoint.group],
    },

    resizable: true,
    donut: {
      center: {
        label: "Total Count",
      },
      alignment: "center",
    },
    pie: {
      labels: {
        formatter: () => void 0,
      },
    },
    height: "200px",
  };
  const getColorCycle = (dataLength) => {
    const colors = [];
    for (let i = 0; i < dataLength; i++) {
      colors.push(baseColors[i % baseColors.length]); // Cycle through base colors
    }
    return colors;
  };
  const mapData = (data) => {
    const array = Object.keys(data).map((key, index) => {
      return { group: key, value: data[key][1] };
    });
    // console.log(array);
    return array;
  };
  const mapDataCount = (data) => {
    const array = Object.keys(data).map((key, index) => {
      return { group: key, value: data[key][0] };
    });
    // console.log(array);
    return array;
  };
  const mapDataBarGraph = (data) => {
    const array = Object.keys(data).map((key) => {
      const quarter = key;
      const main = data[key];
      const subObject = Object.keys(main).reduce((acc, subkey) => {
        acc[subkey] = main[subkey][1]; // Set the value to the second element
        return acc;
      }, {});
      return {
        quarter: quarter,
        ...subObject,
      };
    });

    return array;
  };
  const formatTextInput = (text) => {
    return text.replace("-", ",");
  };
  useEffect(() => {
    setActiveLegend(graphData?.map(() => true));
    if (graphData?.length > 0) {
      const newColorMap = {};
      const colorCycle = getColorCycle(graphData.length);
      graphData.forEach((item, index) => {
        newColorMap[item.group] = colorCycle[index];
      });
      setColorMap(newColorMap);
    }
  }, [graphData]);

  useEffect(() => {
    setGraphData(
      mapData(
        data
          ? data[activeDuration]?.transaction_type_table.overall_mode_summary
          : []
      ),
      true
    );
    setGraphData2(
      mapDataCount(
        data
          ? data[activeDuration]?.transaction_type_table.overall_mode_summary
          : []
      ),
      false
    );
    setBarGraph(
      mapDataBarGraph(
        data
          ? data[activeDuration]?.transaction_type_table?.monthly_mode_summary
          : []
      )
    );
    setSeries(
      mapSeries(
        data ? data[activeDuration]?.transaction_type_table?.legend_array : []
      )
    );
  }, [activeDuration, data]);
  useEffect(() => {
    setOptions({ ...options, data: barGraph, series: series });
  }, [barGraph, series]);

  return (
    <div className=" w-[49.5%] border border-[#e6ebed] rounded-lg  ">
      <div className=" rounded-t-lg bg-[#f3f3f3] py-3 px-4 text-[#212b36] font-bold">
        <p>Transaction Type</p>
      </div>
      <FilterSelector
        activeDuration={activeDuration}
        setActiveDuration={setActiveDuration}
      />
      <div className=" flex w-full px-[30px]  h-fit min-h-[200px] z-[1000] mt-4">
        <div className=" w-[50%]">
          <DonutChart
            data={graphData?.filter((_, index) => activeLegend[index])}
            options={options1}
          ></DonutChart>
        </div>
        <div className=" w-[50%]">
          <DonutChart
            data={graphData2?.filter((_, index) => activeLegend[index])}
            options={options2}
          ></DonutChart>
        </div>
      </div>
      <div className=" ml-6 w-full flex basis-4  flex-wrap pl-[24px] mt-[22px]">
        {legendItems}
      </div>
      <div className=" overflow-x-auto mt-6 ">
        <p className="text-[#212b36] font-bold text-xs ml-[15.75px]">
          Transaction Mode Overview
        </p>
        <div className="mt-1 ">
          <AgCharts options={options} />{" "}
        </div>
      </div>
    </div>
  );
}

export default TransactionType;
